import { IGetCandidateOnsiteInterviewListPayload } from '../../types';

export const factoryGetCandidateOnsiteInterviewListKey = (
  payload: IGetCandidateOnsiteInterviewListPayload,
) => ['GET_CANDIDATE_ONSITE_INTERVIEW_LIST', payload.postingId, payload.professionalId] as const;
